import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import delovnicas from './modules/delovnicas'
import companies from './modules/companies'
import businessUnits from './modules/businessUnits'
import clientsBusinessUnits from './modules/clientsBusinessUnits'
import clientsCertificates from './modules/clientsCertificates'
import users from './modules/users'
import userTypes from './modules/userTypes'
import taxTypes from './modules/taxTypes'
import taxLevels from './modules/taxLevels'
import groups from './modules/groups'
import levels from './modules/levels'
import categories from './modules/categories'
import articles from './modules/articles'
import paymentTypes from './modules/paymentTypes'
import premiseTypes from './modules/premiseTypes'
import measurementUnits from './modules/measurementUnits'
import clientsDevices from './modules/clientsDevices'
import reports from './modules/reports'
import devices from './modules/devices'
import clientsInvoices from './modules/clientsInvoices'
import invoices from './modules/invoices'
import clients from './modules/clients'
import tables from './modules/tables'
import locations from './modules/locations'
import orders from './modules/orders'
import sessions from './modules/sessions'
import printerslocations from './modules/printerslocations'
import acceptanceForms from './modules/acceptanceForms'
import acceptanceFormArticles from './modules/acceptanceFormArticles'
import writeoffForms from './modules/writeoffForms'
import writeoffFormArticles from './modules/writeoffFormArticles'
import inventoryForms from './modules/inventoryForms'
import articleComposition from './modules/articleComposition'
import settings from './modules/settings'
import currentStock from './modules/currentStock'
import articleStock from './modules/articleStock'
import articleCard from './modules/articleCard'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    auth,
    delovnicas,
    companies,
    businessUnits,
    clientsBusinessUnits,
    clientsCertificates,
    users,
    userTypes,
    taxTypes,
    taxLevels,
    groups,
    levels,
    categories,
    articles,
    paymentTypes,
    premiseTypes,
    measurementUnits,
    clientsDevices,
    reports,
    clientsInvoices,
    invoices,
    devices,
    tables,
    locations,
    orders,
    sessions,
    printerslocations,
    clients,
    acceptanceForms,
    acceptanceFormArticles,
    writeoffForms,
    writeoffFormArticles,
    inventoryForms,
    articleComposition,
    currentStock,
    settings,
    articleStock,
    articleCard
  }
})
